import { Pipe, PipeTransform } from '@angular/core';
import { ProductStockViewModel, StockStatus } from '@models/api-search.models';
import { StoreViewModel } from '@models/api.models';

@Pipe({
    name: 'storeStockStatus',
    standalone: true
})
export class StoreStockStatusPipe implements PipeTransform {
    transform(storeStocks: ProductStockViewModel[] | undefined, selectedStore: StoreViewModel): StockStatus | null {
        if (!storeStocks?.length) {
            return null;
        }
        const store = storeStocks.find(stockStore => stockStore.storeId === selectedStore.storeId?.toString());
        if (store) {
            return store.stockStatus;
        }
        return null;
    }
}
